import React from 'react'
import { Text } from 'theme-ui'
import { DownloadItemStyled, DownloadItemTextStyled, DownloadItemIconStyled } from './styles'
import { DownloadItemProps } from './types'
import { IconDownloadDoc } from './../../../assets/svg/index'

const DownloadItem: React.FC<DownloadItemProps> = ({ title, url }) => {
  return (
    <DownloadItemStyled href={url} target="_blank" rel="noreferrer noopener">
      <DownloadItemTextStyled>
        <Text variant="bodyMontserrat21">{title}</Text>
      </DownloadItemTextStyled>
      <DownloadItemIconStyled>
        <IconDownloadDoc />
      </DownloadItemIconStyled>
    </DownloadItemStyled>
  )
}

export default DownloadItem
